(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .controller('NewsDetailController', NewsDetailController);

    NewsDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'News'];

    function NewsDetailController($scope, $rootScope, $stateParams, entity, News) {
        var vm = this;

        vm.news = entity;

        var unsubscribe = $rootScope.$on('valueconnectApp:newsUpdate', function(event, result) {
            vm.news = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
